module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2024_fr-ba937fe240f88316f374050125e00759.jpg";